import Filter from './Filter'

const mapIds = value => {
  if (Array.isArray(value)) return value.join(',')
  return value
}

export default class ApprovedScientificTopics extends Filter {
    filterComponent = import('@/views/components/filters/compoents/ApprovedScientificTopicsFilterComponent.vue')

    static DC_TYPE = 'dc_type'

    static DIRECTION = 'direction'

    static ORGANIZATION = 'organization'

    static PERIOD = 'period_id'

    fields = {
      [ApprovedScientificTopics.DC_TYPE]: {
        label: 'Dc Type',
        mapping: mapIds,
      },
      [ApprovedScientificTopics.DIRECTION]: {
        label: 'Direction',
        mapping: mapIds,
      },
      [ApprovedScientificTopics.ORGANIZATION]: {
        label: 'Organization',
        mapping: mapIds,
      },
      [ApprovedScientificTopics.PERIOD]: {
        label: 'Yillar kesimida',
      },
    }
}
